<template>
  <div class="mb-20 lg:mb-[160px]">
    <BaseBreadcrumb
      v-if="getBreadcrumb"
      class="container my-4 lg:mb-0"
      :breadcrumb="getBreadcrumb"
    />
    <WorldTopBanner />
    <WorldCountries class="my-[56px] lg:my-[120px]" />
    <WorldFindTutor />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { renderHead } from '@helper/head/head-home'
import BaseBreadcrumb from '@design-system/base/breadcrumb/breadcrumb-pages'
import WorldTopBanner from '@/components/pages/world/top-banner'
import WorldFindTutor from '@/components/pages/world/find-tutor'
import WorldCountries from '@/components/pages/world/countries'

export default {
  name: 'WorldPage',
  components: { WorldCountries, WorldFindTutor, WorldTopBanner, BaseBreadcrumb },
  auth: false,
  layout: 'main',
  async asyncData ({ store }) {
    await store.dispatch('local/asyncDataWorld')
  },
  head () {
    return renderHead({ meta: this.getMeta })
  },
  computed: {
    ...mapGetters('global', ['getMeta', 'getBreadcrumb'])
  }
}
</script>

<style scoped>

</style>
